import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore.js";
import { useI18n } from "../i18n/index.js";

export function AuthArea() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const { t } = useI18n();

  if (user) {
    return (
      <div className="flex items-center gap-1">
        <button
          onClick={() => navigate("/profile")}
          className="flex items-center gap-1 hover:opacity-80 transition-opacity"
          title={user.username}
        >
          <div className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center text-xs font-bold uppercase select-none">
            {user.username[0]}
          </div>
          <span className="text-sm text-white/80 hidden sm:inline">{user.username}</span>
        </button>
        <button
          onClick={() => navigate("/settings")}
          className="p-1.5 rounded hover:bg-white/10 transition-colors"
          title={t("game.settings")}
        >
          <img src="/images/btn_settings.png" alt="" className="h-4 w-4 object-contain opacity-50 hover:opacity-80" />
        </button>
        <button
          onClick={() => navigate("/logout")}
          className="p-1.5 rounded hover:bg-white/10 transition-colors"
          title={t("game.logout")}
        >
          <img src="/images/btn_off.png" alt="" className="h-4 w-4 object-contain opacity-50 hover:opacity-80" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => navigate("/settings")}
        className="p-1.5 rounded hover:bg-white/10 transition-colors"
        title={t("game.graphicSettings")}
      >
        <img src="/images/btn_settings.png" alt="" className="h-4 w-4 object-contain opacity-40 hover:opacity-70" />
      </button>
      <button
        onClick={() => navigate("/login")}
        className="px-3 py-1 rounded bg-white/15 hover:bg-white/25 text-sm transition-colors"
      >
        {t("game.login")}
      </button>
    </div>
  );
}
